import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/auth/Login';
import Accueil from './pages/dashboard/Accueil';
import Formulaires from './pages/formulaires/Formulaires';
import Parametres from './pages/parametres/Parametres';
import Utilisateurs from './pages/utilisateurs/Utilisateurs';
import Dashboard from './pages/dashboard/Dashboard';
import ProfilUtilisateur from './pages/utilisateurs/ProfilUtilisateur';
import ResetPassword from './pages/auth/ResetPassword';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromStorage } from './redux/actions/LoginActions';
import PrivateRoutes from './services/PrivateRoutes';
import PartageFormulaire from './pages/formulaires/PartageFormulaire';
import FormPreview from './pages/formulaires/FormPreview';
import Journal from './pages/journal/Journal';
import Share from './pages/Share/Share';
import ViewFormEnregistree from './pages/formulaires/ViewFormEnregistree';
import Test from './pages/Test';
import Sheet from './components/sheet/Sheet';


function App() {
  const dispatch = useDispatch();

   useEffect(() => {
    dispatch(loadUserFromStorage()); 
  }, [dispatch]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          
            <Route path="/" element={<Login />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route path="/dashboard" element={<PrivateRoutes element={<Dashboard />} />} >
              <Route index element={<Accueil />} />
              <Route path="formulaires" element={<Formulaires />} />
              <Route path="parametres" element={<Parametres />} />
              {/* <Route path="resultats" element={<Resultats />} /> */}
              <Route path="utilisateurs" element={<Utilisateurs />} />
              <Route path="profil" element={<ProfilUtilisateur />} />
              <Route path="partage" element={<PartageFormulaire />} />
              <Route path="journal" element={<Journal />} />
              {/* <Route path="test" element={<Test />} /> */}

          </Route>

          <Route path='viewForm' element={<PrivateRoutes element={<FormPreview />} />} />
         <Route path="/viewFormEnregistre/:id"  element={<PrivateRoutes element={<ViewFormEnregistree />} />}  />
          <Route path="forms/share/:token/:id" element={<Share />} />
          <Route path="/sheet/:formId" element={<Sheet />} />


          <Route path="*" element={<div>Page non trouvée</div>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;



